import { mountTimeRemainingPage } from "./time-remaining/components/time-remaining-page";
import { loadJsonLifeExpectancy } from "./time-remaining/adapters/json-life-expectancy";
import { mountSubscribeForm } from "./email-capture/components/subscribe-form";
import { fetchSubscribe } from "./email-capture/adapters/subscribe-port";
import "./styles.css";

const app = document.getElementById("app");

if (app) {
  app.innerHTML = `<p class="loading">Loading life-expectancy data…</p>`;
  loadJsonLifeExpectancy()
    .then((lookup) => {
      mountTimeRemainingPage(app, lookup);
      const subscribeMount = document.createElement("div");
      subscribeMount.className = "subscribe-mount";
      app.appendChild(subscribeMount);
      mountSubscribeForm(subscribeMount, fetchSubscribe);
    })
    .catch((error: unknown) => {
      const message = error instanceof Error ? error.message : String(error);
      app.innerHTML = `<p class="load-error">Failed to load life-expectancy data: ${message}</p>`;
    });
}
